import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { thunk } from "redux-thunk"; // Import named export `thunk`
import loginReducer from "./redux/reducers/login";
import userReducer from "./redux/reducers/user";
import companyReducer from "./redux/reducers/company";
import addressReducer from "./redux/reducers/address";
import feedbackReducer from "./redux/reducers/feedback";
import statsReducer from "./redux/reducers/stats";
import notificationReducer from "./redux/reducers/notification";
import giftReducer from "./redux/reducers/gift";
import activityReducer from "./redux/reducers/activity";
import auditReducer from "./redux/reducers/audit";
import ratingReducer from "./redux/reducers/rating";
import versionReducer from "./redux/reducers/version";
import alertReducer from "./redux/reducers/alert";

const initialState = {};

const loginPersistConfig = {
  key: "login",
  storage,
  blacklist: ["tokenRefresh", "error"],
};

// Only the signed-in user survives a reload: a loading flag saved mid-request
// (e.g. the tab closed during a password reset) kept that button disabled
const userPersistConfig = {
  key: "user",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  login: persistReducer(loginPersistConfig, loginReducer),
  notification: notificationReducer,
  user: persistReducer(userPersistConfig, userReducer),
  company: companyReducer,
  address: addressReducer,
  feedback: feedbackReducer,
  stats: statsReducer,
  gift: giftReducer,
  activity: activityReducer,
  audit: auditReducer,
  rating: ratingReducer,
  version: versionReducer,
  alert: alertReducer,
});

const logger = (store) => (next) => (action) => {
  const result = next(action);
  return result;
};

const middleware = [thunk, logger];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware))
);

const persistor = persistStore(store);

export { store, persistor };
